import { Card, Tabs } from 'antd';
import { Outlet, useMatch } from 'react-router-dom';

import useTypedNavigate from '../../hooks/useTypedNavigate';
import useTypedParams from '../../hooks/useTypedParams';

const StaffExternalIntegrationsNavigator = () => {
  const { tenant } = useTypedParams({ tenant: String });
  const navigate = useTypedNavigate();
  const match = useMatch(':tenant/settings/cs-staff/external-integrations/:activeTabKey/*');
  const activeTabKey = match?.params?.activeTabKey || 'api';

  return (
    <Card>
      <Tabs
        tabPosition="left"
        activeKey={activeTabKey}
        onChange={(key) => {
          switch (key) {
            case 'api':
              navigate(
                {
                  pathname: '/:tenant/settings/cs-staff/external-integrations/api/',
                  params: { tenant },
                },
                { replace: true }
              );
              break;
            case 'sankhya':
              navigate(
                {
                  pathname: '/:tenant/settings/cs-staff/external-integrations/sankhya/',
                  params: { tenant },
                },
                { replace: true }
              );
              break;
            case 'vixting':
              navigate(
                {
                  pathname: '/:tenant/settings/cs-staff/external-integrations/vixting/',
                  params: { tenant },
                },
                { replace: true }
              );
              break;
          }
        }}
        style={{ paddingRight: 24 }}
        items={[
          {
            key: 'api',
            label: 'API Pública',
            children: activeTabKey === 'api' && <Outlet />,
          },
          {
            key: 'sankhya',
            label: 'Sankhya',
            children: activeTabKey === 'sankhya' && <Outlet />,
          },
          {
            key: 'vixting',
            label: 'Vixting',
            children: activeTabKey === 'vixting' && <Outlet />,
          },
        ]}
      />
    </Card>
  );
};

export default StaffExternalIntegrationsNavigator;
